module.exports = __webpack_public_path__ + "static/img/CSUB_Logo.png";